module.exports = __webpack_public_path__ + "/images/shop/icon/more_vertical.svg";